import {
  Box,
  Stack
} from '@mui/material';

import { ActivityDetailSectionCardBaseLayout } from 'modules/components/layer16';
import { SaveDailyReportPhotoModal } from 'modules/components/layer17';
import React, { useState } from 'react';

export type DailyReportPhotoCardProps = {
  id: string;
  photos: { id: string; url: string }[];
};

export const FC = (props: DailyReportPhotoCardProps) => {
  const [
    isVisible,
    setIsVisible
  ] = useState(false);

  return (
    <>
      {isVisible && (
        <SaveDailyReportPhotoModal.FC
          id=''
          isVisible={isVisible}
          handleClose={() => setIsVisible(() => false)}
        />
      )}
      <ActivityDetailSectionCardBaseLayout.FC
        title='Photos'

        subTitle='Additional Photos'
        actionButton={{
          onClick: () => {
            setIsVisible(() => true);
          },
          text: 'Add Photos'
        }}
        editActionButton={null}
        boxProps={{
          flex: '1 1 0'
        }}
      >
        <Stack
          direction='row'
          gap='1rem'
        >
          {props.photos.map((node) => (
            <Box
              key={node.id}
              position='relative'
            >
              {/* <IconButton
                sx={{
                  bgcolor: theme.palette.error.main,

                  position: 'absolute',
                  height: '1.5rem',
                  width: '1.5rem',
                  left: '-.75rem',
                  top: '-.5rem'
                }}
              >
                <CustomIcon.small.FC
                  icon='CLOSE'
                  stroke={theme.palette.error.contrastText}
                />
              </IconButton> */}
              <Box
                component='img'
                src={node.url}
                borderRadius='1rem'
                width='8rem'
                height='8rem'
              />
            </Box>
          ))}
        </Stack>
      </ActivityDetailSectionCardBaseLayout.FC>
    </>
  );
};
